import { Component, Input, OnChanges } from "@angular/core";
import { Chart, registerables } from "chart.js/auto";
import { ObservationResponseAllDto } from "../../../../../common/dtos/observation/observation.response.all";
import ChartDataLabels from "chartjs-plugin-datalabels";

Chart.register(...registerables, ChartDataLabels);

@Component({
  selector: "app-polar-chart",
  templateUrl: "./polar-chart.component.html",
  styleUrls: [
    "./polar-chart.component.scss"
  ]
})
export class PolarChartComponent implements OnChanges {

  public chart: Chart | null = null;
    @Input() data: ObservationResponseAllDto | undefined;

    ngOnChanges(): void {
      if (this.data) {
        this.createCharts(this.data);
      }
    }

    createCharts(result: ObservationResponseAllDto) {
      const activityTypeCounts: { [key: string]: number } = {};

      result.content.forEach((item) => {
        const activityType = item.activity_type as unknown as string;

        if (activityTypeCounts[activityType!]) {
          activityTypeCounts[activityType!]++;
        } else {
          activityTypeCounts[activityType!] = 1;
        }
      });

      const labels = Object.keys(activityTypeCounts);
      const values = Object.values(activityTypeCounts);
      const total = values.reduce((sum, val) => sum + val, 0);

      if (this.chart) {
        this.chart.destroy();
      }

      this.chart = new Chart("PolarAreaChart", {
        type: "pie",
        data: {
          labels,
          datasets: [
            {
              label: "Type",
              data: values,
              backgroundColor: [
                "rgb(255, 99, 132)",
                "rgb(54, 162, 235)",
                "rgb(255, 205, 86)",
                "rgb(61, 212, 94)"
              ],
              hoverOffset: 4
            }
          ]
        },
        options: {
          aspectRatio: 2.5,
          plugins: {
            tooltip: {
              callbacks: {
                label(tooltipItem) {
                  const value = tooltipItem.raw as number;
                  const percentage = ((value / total) * 100).toFixed(1);
                  return `${value} (${percentage}%)`;
                }
              }
            }
          }
        }
      });
    }
}
